import createEvent from '../assets/create-event.png';
import viewAllEvents from '../assets/view-all-events.png';
import viewEvent from '../assets/view-event.png';
import viewHost from '../assets/view-host.png';
import joinEvent from '../assets/join-event.png';
import menuHosts from '../assets/menu-hosts.png';
import menuEvents from '../assets/menu-events.png';
import menuBilling from '../assets/menu-billing.png';
import menuLogout from '../assets/menu-logout.png';
import deleteIcon from '../assets/delete.png';
import add from '../assets/add.png';
import edit from '../assets/edit.png';

import logo from '../assets/logo.png';
const iconMap: Record<string, string> = {
  'create-event': createEvent,
  'view-all-events': viewAllEvents,
  'view-event': viewEvent,
  'view-host': viewHost,
  'join-event': joinEvent,
  'menu-hosts': menuHosts,
  'menu-billing': menuBilling,
  'menu-events': menuEvents,
  'menu-logout': menuLogout,
  'delete': deleteIcon,
  'add': add,
  'edit': edit
};

export const getIcon = (key: string): string => {
  return iconMap[key] || logo;
};